import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';

interface BulkEcommerceDialogProps {
  open: boolean;
  loading: boolean;
  selectedCount: number;
  action: 'open' | 'close' | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const BulkEcommerceDialog: React.FC<BulkEcommerceDialogProps> = ({
  open,
  loading,
  selectedCount,
  action,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={!loading ? onCancel : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {action === 'open' ? 'Toplu E-Ticarete Açma' : 'Toplu E-Ticaretten Kapatma'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Seçili {selectedCount} adet stok ürünü {action === 'open' ? 'e-ticarete açılacak' : 'e-ticaretten kapatılacak'}tır.
        </DialogContentText>
        <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', border: '1px solid #ddd', borderRadius: 1 }}>
          <Typography variant="subtitle2" gutterBottom>
            İşlem Detayları:
          </Typography>
          <Typography variant="body2">
            • Toplam {action === 'open' ? 'açılacak' : 'kapatılacak'} ürün sayısı: {selectedCount}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {action === 'open' 
              ? 'Seçili ürünler e-ticaret sitesinde görünür hale gelecektir.'
              : 'Seçili ürünler e-ticaret sitesinden kaldırılacaktır.'
            }
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onCancel} 
          color="primary"
          disabled={loading}
        >
          İptal
        </Button>
        <Button 
          onClick={onConfirm} 
          color={action === 'open' ? 'success' : 'warning'} 
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={24} color="inherit" /> : <StorefrontIcon />}
        >
          {loading 
            ? (action === 'open' ? 'Açılıyor...' : 'Kapatılıyor...') 
            : (action === 'open' ? `${selectedCount} Ürünü Aç` : `${selectedCount} Ürünü Kapat`)
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

